import React, { Fragment, useState, useRef, useEffect } from 'react';
import { Dialog, Disclosure, Menu, Transition } from '@headlessui/react';
import {
  Bars3Icon,
  BellIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import GenToolsList from '../pages/tools/gen_tools_list';
import UserAvatar from '../pages/authentication/UserAvatar';
import { useStore } from '../hooks/use-store';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { stepsArr } from '../store/sop-store';
import fileIcon from '../../src/icons/file.svg';
import folderOpenIcon from '../../src/icons/folderOpen.svg';
import pencilIcon from '../../src/icons/pencil.svg';
import coinWhite from '../../src/icons/coinWhite.svg';
import TWModal from '../components/TWModal';
import RenameNewDocument from '../pages/dashboard/rename_new_doument';
import SopFile from '../pages/sop-file/sop-file';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const ModalConfirmationDialog = observer((props) => {
  const { dashboardStore, sopStore, newContentStore , resumeStore ,sopProfileSelectionStore} = useStore();
  const { modalWarningDialog } = dashboardStore;
  const navigate = useNavigate();
  //const [modalWarningDialog, setModalWarningDialog] = useState(true)
                      
  return (
    <Transition.Root show={modalWarningDialog} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => {
          dashboardStore.setModalWarningDialog(false);
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={() => {
                      dashboardStore.setModalWarningDialog(false);
                    }}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      Discard Current SOP
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Are you sure you want to discard current SOP? If not, please save all your
                        changes and then navigate away from SOP.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
                    onClick={() => {
                      const stepName = sopStore.activeStep;
                      sopStore.markCompleted(stepName);
                     
                      if(sopStore.activeStep === 'Step 1'){
                        sopStore.save_sop_file(sopProfileSelectionStore.sopProfileFolderId , newContentStore.parentId,sopProfileSelectionStore.current_sop_name)        
                         }
                         else{
                          sopStore.update_sop_workspace(sopStore.folderid, sopStore.sopId);
                         }
                      const index = stepsArr.indexOf(sopStore.activeStep);
                      if (index + 1 <= 4) {
                        sopStore.set_active_step(stepsArr[index + 1]);
                      }
                      dashboardStore.setModalWarningDialog(false);
                      dashboardStore.updateCurrentStatusForDashboardNav(
                        dashboardStore.modalConfirmNavigatePath
                      );
                      // navigate('/dashboard');
                    }}
                  >
                    Save & Proceed
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => {
                      dashboardStore.setModalWarningDialog(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
});

// @ts-ignore
export const AuthenticatedLayout = observer(({ children }) => {
  const { userStore, dashboardStore, sopStore,newContentStore,newToolsStore ,uKSopStore , userProfileStore} = useStore();
  const location = useLocation();
  const navigate = useNavigate();
  const [showRenameDocModal, setShowRenameDocModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
const rechargeHandler=()=>{
window.open('/paymentspage')
}

  const topbar = (
    <nav
      id="navbar"
      className={`z-[2] h-20 fixed top-0 flex bg-white px-4 items-center flex-row justify-between border-b border-gray-300 py-4`}
      style={{ width: dashboardStore.showDashboardSideBar ? 'calc(100vw - 320px)' : '100vw' }}
    >
      <div className="flex flex-row items-center">
        <button
          id="btnSidebarToggler"
          type="button"
          className="text-2xl text-black ml-[5px]"
          onClick={() => {
            dashboardStore.toggleShowDashboardSideBar();
          }}
        >
          {dashboardStore.showDashboardSideBar ? (
            <></>
          ) : (
            <div className="h-10 w-10 flex items-center justify-center rounded-full bg-[#F8F9FA]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
                />
              </svg>
            </div>
          )}
        </button>
        <div className={`flex flex-col ${dashboardStore.showDashboardSideBar ? 'ml-4' : 'ml-6'}`}>
          <h3 className={`font-bold font-Avenir text-xl text-[#292D35]`}>{dashboardStore.screenName}</h3>
          {dashboardStore.screenName == 'Statement of Purpose' && (
            <div className="flex">
              <div className="flex items-center mt-1">
                {sopStore.breadCrumbs &&
                  sopStore.breadCrumbs.length > 0 &&
                  sopStore.breadCrumbs.map((item: any, index) => {
                    return (
                      <>
                        {index > 0 && <i className="fa-light fa-angle-right mx-3"></i>}
                        {item.isfile ? (
                          <img className="mr-2 cursor-pointer" src={fileIcon} />
                        ) : (
                          <img
                           // onClick={() => setIsOpen(true)}
                           className="mr-2"
                            src={folderOpenIcon}
                          />
                        )}
                        <p className="#737E93 text-[12px] cursor-pointer">{item.name}</p>{' '}
                        {sopStore.breadCrumbs.length - 1 === index && item.isfile ? (
                          <img
                            title="Rename Document"
                            onClick={() => setShowRenameDocModal(true)}
                            className="ml-2 cursor-pointer"
                            src={pencilIcon}
                          />
                        ) : null}
                      </>
                    );
                  })}
              </div>

              {/* <div className="my-1 flex items-center">
                <img onClick={() => setIsOpen(true)} className="mr-2 " src={fileIcon} />
                <p className="text-[#737E93] text-base">{sopStore.sopName}</p>
                <img
                  title="Rename Document"
                  onClick={() => setShowRenameDocModal(true)}
                  className="ml-2 cursor-pointer"
                  src={pencilIcon}
                />
              </div> */}
            </div>
          )}
        </div>
      </div>

      <div className=" ">
        <UserAvatar />
      </div>
    </nav>
  );

  const sidebar = (
    <div id="containerSidebar" className="z-[999]">
      <div className="navbar-menu relative z-[999]">
        <nav
          id="sidebar"
          className={classNames(
            dashboardStore.showDashboardSideBar ? 'show' : 'hidden',
            'fixed h-full flex w-3/4 -translate-x-full flex-col overflow-x-hidden overflow-y-auto bg-[#131720] pt-6 pb-2 sm:max-w-xs lg:w-80'
          )}
        >
          <div className="pl-[24px]">
            <div className="flex flex-row items-center">
              <button
                type="button"
                className="text-xl text-white mr-4"
                onClick={() => {
                  dashboardStore.setShowDashboardSideBar(false);
                }}
              >
                <div className="h-10 w-10 flex items-center justify-center rounded-full bg-gray-600">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="#FEFEFE"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
                    />
                  </svg>
                </div>
              </button>
              <img src="/cambri-logo-white.png" style={{ height: '36px' }} alt="Cambri" />
            </div>
          </div>

          <div className="mt-10">
            <ul role="list" className="flex flex-1 flex-col gap-y-7">
              <li>
                <ul role="list" className="-mx-2 space-y-1">
                  {dashboardStore.dashboardNavigation.map((item) => (
                    <li key={item.name}>
                      <div
                        className={classNames(
                          item.current
                            ? 'bg-purple-800 text-[#F1F2F4]'
                            : 'text-[#ABB2BE] hover:text-white hover:bg-purple-800',
                          'pl-[37px] py-3 group items-center flex gap-x-3 rounded-md text-[16px] leading-6 cursor-pointer'
                        )}
                        onClick={() => {
                          navigate(item.href)
                          //Check for current path
                          if (location.pathname === '/sop') {
                            dashboardStore.setModalWarningDialog(true);
                            dashboardStore.setModalConfirmNavigatePath(item.name);
                          } else {
                            dashboardStore.updateCurrentStatusForDashboardNav(item.name);
                            // navigate('/sop');
                            sopStore.setFinalOutputScreen(false);
                          }
                          dashboardStore.setShowDashboardSideBar(false);
                        }}
                      >
                        <img
                          className="mr-2 cursor-pointer"
                          src={item.icon} // Use the img-src here
                          alt={item.name}
                        />
                        {item.name}
                      </div>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </div>

          <div className="mt-auto">
            <div className="px-4">
              <div className="rounded-lg bg-[#150437] border border-[#4E5664] text-white p-6 flex flex-col">
                <div className="flex flex-row">
                  <img src={coinWhite} alt="coins.svg" />
                  <div className="text-sm pl-2">Credits</div>
                </div>
                <div className="font-bold text-[24px] pt-1 pb-4">{newToolsStore.credits || sopStore.availableCredits || uKSopStore.availableCredits || newContentStore.credits || userProfileStore.availableCredits ? sopStore.availableCredits || newToolsStore.credits || uKSopStore.availableCredits  || newContentStore.credits || userProfileStore.availableCredits :0}</div>
                <button className="bg-purple-700 text-white text-[14px] p-4 uppercase rounded-lg cursor-pointer" onClick={rechargeHandler}>
                  Recharge
                </button>
              </div>
            </div>

            <div className="border border-gray-500 my-4" />

            {/* <div className="flex flex-row items-center justify-center">
              <svg
                className="mr-4"
                width="24"
                height="18"
                viewBox="0 0 24 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.2037 13.3486L20.4372 2.43707C20.3644 2.15301 20.2103 1.89634 19.9938 1.69852C19.7774 1.5007 19.5079 1.37031 19.2184 1.32332L15.8378 0.768323C15.4651 0.708381 15.0835 0.789194 14.7671 0.995045C14.4507 1.2009 14.2221 1.51707 14.1259 1.88207L14.1062 1.96176C14.0935 2.01239 14.0915 2.06512 14.1003 2.11658C14.1091 2.16804 14.1285 2.21709 14.1574 2.2606C14.1862 2.30411 14.2239 2.34111 14.2679 2.36924C14.3118 2.39737 14.3612 2.416 14.4128 2.42395C15.1885 2.5378 15.9538 2.71399 16.7012 2.95082C16.8881 3.0072 17.0465 3.13254 17.1444 3.30141C17.2422 3.47029 17.2721 3.67006 17.2281 3.8602C17.2028 3.95928 17.1575 4.05215 17.095 4.13308C17.0325 4.21402 16.9541 4.28132 16.8646 4.33084C16.7752 4.38036 16.6765 4.41106 16.5747 4.42106C16.4729 4.43105 16.3702 4.42012 16.2728 4.38895C13.4995 3.53843 10.5355 3.53517 7.76031 4.37957C7.5725 4.44272 7.36758 4.4311 7.18812 4.34713C7.00865 4.26316 6.86842 4.11328 6.79656 3.92864C6.7624 3.83389 6.74768 3.73323 6.75327 3.63266C6.75885 3.5321 6.78464 3.43369 6.82909 3.34331C6.87354 3.25293 6.93573 3.17243 7.01197 3.10661C7.0882 3.04078 7.17691 2.99099 7.27281 2.9602C8.02956 2.71916 8.80459 2.53982 9.59031 2.42395C9.64191 2.416 9.69128 2.39737 9.73526 2.36924C9.77924 2.34111 9.81687 2.30411 9.84572 2.2606C9.87458 2.21709 9.89404 2.16804 9.90284 2.11658C9.91165 2.06512 9.90962 2.01239 9.89687 1.96176L9.87718 1.88207C9.78095 1.51676 9.55209 1.20038 9.23525 0.994645C8.91841 0.788906 8.5363 0.708555 8.16343 0.76926L4.78093 1.32426C4.49159 1.37118 4.22221 1.50143 4.00575 1.69907C3.78929 1.89672 3.63514 2.15318 3.56218 2.43707L0.795618 13.3486C0.708874 13.6916 0.746626 14.0543 0.902159 14.372C1.05769 14.6898 1.32092 14.942 1.64499 15.0839L7.92624 17.8693C8.11511 17.9532 8.31916 17.9977 8.52584 17.9999C8.73252 18.0021 8.93747 17.962 9.12809 17.8821C9.31872 17.8022 9.49099 17.6842 9.63432 17.5353C9.77765 17.3863 9.88901 17.2097 9.96156 17.0161L10.2887 16.1302C10.3082 16.0771 10.3155 16.0203 10.3099 15.9641C10.3044 15.9078 10.2862 15.8535 10.2567 15.8053C10.2272 15.7571 10.1872 15.7161 10.1397 15.6855C10.0921 15.6549 10.0383 15.6355 9.98218 15.6286C9.07144 15.5184 8.17289 15.3238 7.29812 15.0474C7.11204 14.9908 6.95431 14.8658 6.85671 14.6976C6.75912 14.5294 6.72891 14.3304 6.77218 14.1408C6.79726 14.0415 6.84243 13.9483 6.90492 13.8671C6.9674 13.7858 7.04587 13.7183 7.13547 13.6686C7.22508 13.6188 7.32392 13.588 7.42591 13.578C7.52789 13.5679 7.63085 13.5789 7.72843 13.6102C10.5121 14.4627 13.4872 14.4627 16.2709 13.6102C16.3684 13.579 16.4712 13.5681 16.573 13.5782C16.6748 13.5883 16.7735 13.619 16.863 13.6686C16.9525 13.7183 17.0309 13.7857 17.0934 13.8667C17.1558 13.9477 17.201 14.0407 17.2262 14.1399C17.27 14.3296 17.24 14.5289 17.1424 14.6974C17.0447 14.8659 16.8867 14.991 16.7003 15.0474C15.8259 15.3239 14.9276 15.5184 14.0172 15.6286C13.9611 15.6355 13.9072 15.6549 13.8597 15.6855C13.8121 15.7161 13.7721 15.7571 13.7426 15.8053C13.7132 15.8535 13.695 15.9078 13.6894 15.9641C13.6839 16.0203 13.6911 16.0771 13.7106 16.1302L14.0378 17.0161C14.1105 17.2096 14.2219 17.3862 14.3652 17.535C14.5086 17.6839 14.6808 17.8018 14.8714 17.8817C15.062 17.9616 15.2669 18.0017 15.4736 17.9996C15.6802 17.9974 15.8842 17.9531 16.0731 17.8693L22.3544 15.0839C22.6784 14.942 22.9417 14.6898 23.0972 14.372C23.2527 14.0543 23.2905 13.6916 23.2037 13.3486ZM8.62468 11.2496C8.40218 11.2496 8.18467 11.1836 7.99966 11.06C7.81466 10.9364 7.67046 10.7607 7.58532 10.5551C7.50017 10.3495 7.47789 10.1233 7.5213 9.9051C7.56471 9.68687 7.67185 9.48641 7.82919 9.32908C7.98652 9.17174 8.18698 9.0646 8.4052 9.02119C8.62343 8.97778 8.84963 9.00006 9.0552 9.08521C9.26077 9.17036 9.43647 9.31455 9.56008 9.49956C9.6837 9.68456 9.74968 9.90207 9.74968 10.1246C9.74968 10.4229 9.63116 10.7091 9.42018 10.9201C9.2092 11.131 8.92305 11.2496 8.62468 11.2496ZM15.3747 11.2496C15.1522 11.2496 14.9347 11.1836 14.7497 11.06C14.5647 10.9364 14.4205 10.7607 14.3353 10.5551C14.2502 10.3495 14.2279 10.1233 14.2713 9.9051C14.3147 9.68687 14.4219 9.48641 14.5792 9.32908C14.7365 9.17174 14.937 9.0646 15.1552 9.02119C15.3734 8.97778 15.5996 9.00006 15.8052 9.08521C16.0108 9.17036 16.1865 9.31455 16.3101 9.49956C16.4337 9.68456 16.4997 9.90207 16.4997 10.1246C16.4997 10.4229 16.3812 10.7091 16.1702 10.9201C15.9592 11.131 15.673 11.2496 15.3747 11.2496Z"
                  fill="#F1F2F4"
                />
              </svg>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5 0.25H5.5C4.10807 0.251489 2.77358 0.805091 1.78933 1.78933C0.805091 2.77358 0.251489 4.10807 0.25 5.5V14.5C0.251489 15.8919 0.805091 17.2264 1.78933 18.2107C2.77358 19.1949 4.10807 19.7485 5.5 19.75H14.5C15.8919 19.7485 17.2264 19.1949 18.2107 18.2107C19.1949 17.2264 19.7485 15.8919 19.75 14.5V5.5C19.7485 4.10807 19.1949 2.77358 18.2107 1.78933C17.2264 0.805091 15.8919 0.251489 14.5 0.25ZM10 14.5C9.10998 14.5 8.23995 14.2361 7.49993 13.7416C6.75991 13.2471 6.18314 12.5443 5.84254 11.7221C5.50195 10.8998 5.41283 9.99501 5.58647 9.12209C5.7601 8.24918 6.18868 7.44736 6.81802 6.81802C7.44736 6.18868 8.24918 5.7601 9.12209 5.58647C9.99501 5.41283 10.8998 5.50195 11.7221 5.84254C12.5443 6.18314 13.2471 6.75991 13.7416 7.49993C14.2361 8.23995 14.5 9.10998 14.5 10C14.4988 11.1931 14.0243 12.337 13.1806 13.1806C12.337 14.0243 11.1931 14.4988 10 14.5ZM15.625 5.5C15.4025 5.5 15.185 5.43402 15 5.3104C14.815 5.18679 14.6708 5.01109 14.5856 4.80552C14.5005 4.59995 14.4782 4.37375 14.5216 4.15552C14.565 3.93729 14.6722 3.73684 14.8295 3.5795C14.9868 3.42217 15.1873 3.31502 15.4055 3.27162C15.6238 3.22821 15.85 3.25049 16.0555 3.33564C16.2611 3.42078 16.4368 3.56498 16.5604 3.74998C16.684 3.93499 16.75 4.1525 16.75 4.375C16.75 4.67337 16.6315 4.95952 16.4205 5.1705C16.2095 5.38147 15.9234 5.5 15.625 5.5ZM13 10C13 10.5933 12.8241 11.1734 12.4944 11.6667C12.1648 12.1601 11.6962 12.5446 11.1481 12.7716C10.5999 12.9987 9.99667 13.0581 9.41473 12.9424C8.83279 12.8266 8.29824 12.5409 7.87868 12.1213C7.45912 11.7018 7.1734 11.1672 7.05764 10.5853C6.94189 10.0033 7.0013 9.40013 7.22836 8.85195C7.45542 8.30377 7.83994 7.83524 8.33329 7.50559C8.82664 7.17595 9.40666 7 10 7C10.7956 7 11.5587 7.31607 12.1213 7.87868C12.6839 8.44129 13 9.20435 13 10Z"
                  fill="#F1F2F4"
                />
              </svg>
            </div> */}
          </div>
        </nav>
      </div>
      <div className="mx-auto lg:ml-80"></div>
    </div>
  );

  const main = <main className="mt-10">{children}</main>;
  return (
    <>
      <div className="flex flex-row bg-[#f8f9fd] overflow-hidden">
        {dashboardStore.showDashboardSideBar && sidebar}
        <div className="w-full">
          {topbar}
          {main}
        </div>
      </div>
      <ModalConfirmationDialog />
      <SopFile isOpen={isOpen} setIsOpen={setIsOpen} />
      <TWModal
        show={showRenameDocModal}
        children={
          <RenameNewDocument
            setShowRenameDocModal={setShowRenameDocModal}
            activeDoc={{ name: sopStore.sopName, id: sopStore.sopId, isfile: true }}
          />
        }
        onClose={() => setShowRenameDocModal(false)}
      />
    </>
  );
});
